import { DELETE_TAG } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DELETE_TAG.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DELETE_TAG.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case DELETE_TAG.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
